import React from 'react';
import { breakpoint } from '../../styling/mixins/breakpoints';
import styled from 'styled-components';
import { fontFamilyBold } from '../../styling/variables/typography';

const QuickSearchNoHitWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${breakpoint('large')} {
    margin-bottom: 3.2rem;
  }
  .container {
    display: flex;
    align-items: center;
    text-align: center;
    flex-direction: column;
  }
  .icon {
    font-size: 6rem;
  }
  .title {
    ${fontFamilyBold}
    margin-top: 1.4rem;
  }
  .description {
    margin-top: 0.8rem;
  }
`;

const QuickSearchNoHit = (props) => {
  const { title, description } = props;

  return (
    <QuickSearchNoHitWrapper>
      <div className="container">
        {title && <h4 className="title">{title}</h4>}
        {description && (
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: description.value,
            }}
          />
        )}
      </div>
    </QuickSearchNoHitWrapper>
  );
};

export default QuickSearchNoHit;
